
import { defineComponent, ref, reactive, computed } from "vue";
import visits from "@/visits/composables/useVisits";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import date from "date-and-time";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
//import { useRoute } from "vue-router";
export default defineComponent({
  name: "liftRestriction",
  components: {},
  emits: ["reloadTable"],
  setup(props, { emit }) {
      const { registerLiftRestriction } = visits();
      const now = new Date();
      const pattern = date.compile("YYYY-MM-DD");
      const currentDate = date.format(now, pattern);
      const isLoading = ref(false);
      const state: any = reactive({
        formData: {
          id_restriccion:"",
          memorandum_levantamiento_restriccion: "",
          fecha_levantamiento_restriccion: "",
        },
      });
      const isOpenClose = ref<boolean>(false);
      const showModal = async (dialog: boolean, id_restriction: number) => {
        isOpenClose.value = dialog;
        state.formData.id_restriccion = id_restriction;
      };
      const OpenCloseModal = () => {
        isOpenClose.value = false;
        state.formData.id_restriccion = "";
        state.formData.memorandum_levantamiento_restriccion = "";
        state.formData.fecha_levantamiento_restriccion = "";
        v$.value.$reset();
      };
      const rules = computed(() => {
        return {
          formData: {
            memorandum_levantamiento_restriccion: { required },
            fecha_levantamiento_restriccion: {required}
          },
        };
      });
      const v$ = useVuelidate(rules, state);   
      const register = async () => {
      const isFormCorrect = await v$.value.$validate();
      if (!isFormCorrect) return;
       try {
         isLoading.value=true
         const { data } = await registerLiftRestriction(state.formData);
      if (data.ok) {
        isLoading.value=false
        Swal.fire({
          title: "¡Realizado!",
          text: `Registro de restricción realizado correctamente`,
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
            OpenCloseModal()
            emit("reloadTable", "active");
      }
       } catch (error) {
         console.error('Error submitting form:', error);
       }
      };   
    return {
      state,
      showModal,
      isOpenClose,
      OpenCloseModal,
      currentDate,
      v$,
      isLoading,
      verifyDate: async () => {
        if(state.formData.fecha_levantamiento_restriccion>currentDate){
          Swal.fire({
                icon: "warning",
                title:"fecha de levantamiento de restricción errónea",
                text: `¡La fecha de levantamiento de la restricción no puede ser posterior a la fecha actual!`,
              });
        state.formData.fecha_levantamiento_restriccion = '';
        }
      },
      register
    };
  },
  directives: {
      // transform input to uppercase with v-uppercase
      uppercase: {
        updated: function (el) {
          el.value = el.value.toUpperCase();
          el.dispatchEvent(new Event("input"));
        },
      },
    },
});
